import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG } from '../../config/rest';
import {
  AGENCY_INCIDENT_ENDPOINT,
  INCIDENT_RECORD_ENDPOINT,
} from '../../config/endpoints';
import { ACTIVITY_AGENCY_INCIDENT, CLEAR_AGENCY_INCIDENTS, FLAG_GETTING_AGENCY_INCIDENTS, GET_AGENCY_INCIDENTS } from '../types/supervision-control/AgencyIncident';

const flagGettingAgencyIncidents = (flag) => (dispatch) =>
  dispatch({ type: FLAG_GETTING_AGENCY_INCIDENTS, payload: flag });

const getAgencyIncidents =
  ({ agencyId, dateString }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingAgencyIncidents(true));
      const query = QueryString.stringify({ agencyId, dateString });
      const url = `${AGENCY_INCIDENT_ENDPOINT}?${query}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const payload = await response.json();
      dispatch({ type: GET_AGENCY_INCIDENTS, payload });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingAgencyIncidents(false));
    }
  };

const clearAgencyIncidents = () => (dispatch) =>
  dispatch({ type: CLEAR_AGENCY_INCIDENTS });

const flagActivityAgencyIncident = (flag) => (dispatch) =>
  dispatch({ type: ACTIVITY_AGENCY_INCIDENT, payload: flag });

const postAgencyIncident =
  async ({
    incidentRecordType,
    incidentId,
    incidentSubtypeId,
    note,
    agencyId,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagActivityAgencyIncident(true));
      const body = JSON.stringify({
        incidentRecordType,
        incidentId,
        incidentSubtypeId,
        note,
        agencyId,
      });
      const response = await fetch(INCIDENT_RECORD_ENDPOINT, {
        ...DEFAULT_POST_CONFIG,
        body,
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Éxito', 'Incidente diario registrado correctamente');
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagActivityAgencyIncident(false));
    }
  };

export { getAgencyIncidents, clearAgencyIncidents, postAgencyIncident };
